import request from '@/utils/request'

// ============== 管理员接口 ==============

// 获取定时任务列表（管理员）
export function getAdminScheduleList(params) {
  return request({
    url: '/admin/schedules',
    method: 'get',
    params
  })
}

// 获取定时任务详情（管理员）
export function getAdminScheduleDetail(id) {
  return request({
    url: `/admin/schedules/${id}`,
    method: 'get'
  })
}

// 切换定时任务启用状态（管理员）
export function toggleAdminSchedule(id, enabled) {
  return request({
    url: `/admin/schedules/${id}/toggle`,
    method: 'post',
    data: { enabled }
  })
}

// 删除定时任务（管理员）
export function deleteAdminSchedule(id) {
  return request({
    url: `/admin/schedules/${id}`,
    method: 'delete'
  })
}

// 批量删除定时任务（管理员）
export function batchDeleteAdminSchedules(ids) {
  return request({
    url: '/admin/schedules/batch',
    method: 'delete',
    data: { ids }
  })
}

// ============== 用户接口 ==============

// 获取定时任务列表
export function getScheduledTasks(params) {
  return request({
    url: '/schedules',
    method: 'get',
    params
  })
}

// 获取单个定时任务详情
export function getScheduledTask(id) {
  return request({
    url: `/schedules/${id}`,
    method: 'get'
  })
}

// 创建定时任务
export function createScheduledTask(data) {
  return request({
    url: '/schedules',
    method: 'post',
    data
  })
}

// 更新定时任务
export function updateScheduledTask(id, data) {
  return request({
    url: `/schedules/${id}`,
    method: 'put',
    data
  })
}

// 删除定时任务
export function deleteScheduledTask(id) {
  return request({
    url: `/schedules/${id}`,
    method: 'delete'
  })
}

// 切换任务启用状态
export function toggleScheduledTask(id, enabled) {
  return request({
    url: `/schedules/${id}/toggle`,
    method: 'post',
    data: { enabled }
  })
}

// 获取调度器统计信息
export function getSchedulerStats() {
  return request({
    url: '/schedules/stats',
    method: 'get'
  })
}
